// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput__container___4ONvp","icon":"SearchInput__icon___1DqFE","input":"SearchInput__input___1P9uO"};